// src/components/PostCard/index.jsx
import React from 'react';
import { Card, Tag, Avatar, Space, Typography, Statistic } from 'antd';
import { 
  EyeOutlined, 
  LikeOutlined, 
  MessageOutlined, 
  CalendarOutlined,
  UserOutlined 
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './index.css';

const { Text, Paragraph } = Typography;
const { Countdown } = Statistic;

const PostCard = ({ post }) => {
  // 计算阅读时间（假设每分钟300字）
  const readingTime = Math.ceil(post.content.length / 300);

  return (
    <Card
      className="post-card"
      hoverable
      cover={
        post.coverImage && (
          <div className="post-cover">
            <img 
              alt={post.title} 
              src={post.coverImage}
              className="cover-image"
            />
          </div>
        )
      }
    >
      {/* 文章分类和标签 */}
      <Space className="post-meta" size={[8, 8]} wrap>
        <Tag color="blue" icon={<CalendarOutlined />}>
          {post.category}
        </Tag>
        {post.tags?.slice(0, 3).map((tag, index) => (
          <Tag key={index} color="default">
            #{tag}
          </Tag>
        ))}
      </Space>

      {/* 文章标题 */}
      <Link to={`/post/${post.id}`}>
        <h3 className="post-title">{post.title}</h3>
      </Link>

      {/* 文章摘要 */}
      <Paragraph 
        ellipsis={{ rows: 2 }} 
        className="post-summary"
      >
        {post.summary || post.content.substring(0, 150)}...
      </Paragraph>

      {/* 作者信息 */}
      <Space className="post-author" size="small" align="center">
        <Avatar 
          size="small" 
          icon={<UserOutlined />}
          src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${post.author}`}
        />
        <Text type="secondary">{post.author}</Text>
        <Text type="secondary">·</Text>
        <Text type="secondary">{post.createdAt}</Text>
      </Space>

      {/* 文章统计 */}
      <div className="post-stats">
        <Space size="large">
          <span className="stat-item">
            <EyeOutlined /> {post.views}
          </span>
          <span className="stat-item">
            <LikeOutlined /> {post.likes}
          </span>
          <span className="stat-item">
            <MessageOutlined /> {post.comments}
          </span>
          <span className="stat-item">
            ⏱️ {readingTime}分钟
          </span>
        </Space>
      </div>

      {/* 操作按钮 */}
      <div className="post-actions">
        <Link to={`/post/${post.id}`}>
          <Text type="primary" strong>阅读全文 →</Text>
        </Link>
      </div>
    </Card>
  );
};

export default PostCard;